#import "../../../../core/select/fragments/market-fragment.graphql"
#import "../../../../categories/graphql/fragments/product-category-fragment.graphql"
fragment ProductFragment on Product {
    id
    name
    description
    createdTime
    sku
    category {
        ...ProductCategoryFragment
    }
    type
    term
    lastUsedTime
    markets(first: 1000) {
        edges {
            node {
                ...MarketFragment
            }
            price {
                amount
                symbol
                formattedWithCents
            }
            isAvailable
        }
    }
}
